import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_edit_product",
  ref: "editProductModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_edit_product_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Edit a Product", -1)
const _hoisted_6 = {
  id: "kt_modal_edit_product_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_edit_product_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_edit_product_header",
  "data-kt-scroll-wrappers": "#kt_modal_edit_product_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "fv-row mb-7" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "SKU ID", -1)
const _hoisted_12 = { class: "fv-row mb-7" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Title", -1)
const _hoisted_14 = { class: "fv-row mb-7" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Box", -1)
const _hoisted_16 = { class: "fv-row mb-7" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Min", -1)
const _hoisted_18 = { class: "fv-row mb-7" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Max", -1)
const _hoisted_20 = { class: "modal-footer flex-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_edit_product_cancel",
  class: "btn btn-light me-3"
}, " Discard ", -1)
const _hoisted_22 = ["data-kt-indicator"]
const _hoisted_23 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_25 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_26 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_el_form_item, { prop: "skuID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.skuID,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.skuID) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_el_form_item, { prop: "title" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.title,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.title) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_form_item, { prop: "box" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.box,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.box) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_form_item, { prop: "min" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.min,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.min) = $event)),
                        type: "number",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_el_form_item, { prop: "max" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.max,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.max) = $event)),
                        type: "number",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("span", _hoisted_25, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _hoisted_29))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_22)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}